
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class ReportSaleTaxDialog extends Serenity.EntityDialog<ReportSaleTaxRow, any> {
        protected getFormKey() { return ReportSaleTaxForm.formKey; }
        protected getIdProperty() { return ReportSaleTaxRow.idProperty; }
        protected getLocalTextPrefix() { return ReportSaleTaxRow.localTextPrefix; }
        protected getNameProperty() { return ReportSaleTaxRow.nameProperty; }
        protected getService() { return ReportSaleTaxService.baseUrl; }
        protected getDeletePermission() { return ReportSaleTaxRow.deletePermission; }
        protected getInsertPermission() { return ReportSaleTaxRow.insertPermission; }
        protected getUpdatePermission() { return ReportSaleTaxRow.updatePermission; }

        protected form = new ReportSaleTaxForm(this.idPrefix);

    }
}